<div class="form-group">
    {[ if (o.type !== 'hidden') { ]}
        <label for="{{{o.id}}}">{{{o.label}}}</label>
    {[ } ]}
    <input class="form-control" name="{{{o.name}}}" type="{{{o.type}}}" id="{{{o.id}}}"
        {[ if (o.placeholder) { ]} placeholder="{{{o.placeholder}}}" {[ } ]}
        {[ if (o.value) { ]} value="{{{o.value}}}" {[ } ]}
        {[ if (o.required) { ]} required {[ } ]} />
</div>
